export default "__VITE_ASSET__BOfKSeuz__"